// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"8c5fb744","703":"2ae8145f"}[chunkId] + ".chunk.js";
};